<div class="form-group"
     [class.has-error]="errors()"
     [formGroup]="formGroup">
  <label class="control-label tw-flex tw-items-center tw-gap-spacing-25">
    {{ schemaTranslations()?.getFieldTranslation(controlName()) }}
    @if (properties() | propertyIsFieldRequired:controlName()) {
      <span class="required with-hint">*</span>
    }
    @if (properties() | showPropertyArrayHint: controlName()) {
      <app-hint
          [tooltipText]="(properties() | propertyArrayHintText: controlName()) | translate:(properties() | propertyGetFields:controlName())"/>
    }
  </label>
  @for (enumValue of properties() | propertyGetEnumValues:controlName(); track enumValue) {
    <div class="checkbox">
      <label [htmlFor]="controlName() + '_' + enumValue">
        <input type="checkbox"
               [name]="controlName()"
               [id]="controlName() + '_' + enumValue"
               [formControlName]="enumValue"><span class="checkbox-material"><span class="check"></span></span>
        {{ (properties() | propertyHasNumericValues:controlName()) ? enumValue : schemaTranslations()?.getEnumTranslation(controlName(), enumValue) }}
      </label>
    </div>
  }
  @if (properties() | showPropertyArraySelectAllButton:controlName()) {
    <button
        class="btn btn-primary btn-raised"
        type="button"
        (click)="selectAll()">
      {{ 'profile-form.array_property.select_all' | translate }}
    </button>
  }
</div>
